import React from "react";

import { lessonRetrospectPath } from "../../../teacherStore";
import SelectTextbook from "../../../templates/Select/Textbook";
import { TEACHER_SESSION_KEY } from "../../../Definition";

export default () => {
  const extra = sessionStorage.getItem(TEACHER_SESSION_KEY)
    ? `?session_id=${sessionStorage.getItem(TEACHER_SESSION_KEY)}`
    : "";

  return (
    <SelectTextbook
      basicPath={`${process.env.REACT_APP_ONE_MENU_URL}/class_retrospect${extra}`}
      activeLearningPath={`${lessonRetrospectPath}?isActiveLearning=true`}
      has_base={false}
    />
  );
};
